// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper___Yc14","content":"footer_content__3jPw-"};